// -------------------------------------
// Headroom
// -------------------------------------
(function($) {

  // $(window).resize(function() {
  var $navbar = $("#mainNavbar");

  if ($navbar != null) {

    var $wrapper = $navbar.parent(".navbar-wrapper");
    var $bgcolor = $navbar.css("background-color");
    var $offset = $navbar.offset();

    // Set height and background color of wrapper
    $(window).on("resize", function() {
      var $height = $navbar.outerHeight();
      $wrapper.height($height).css({
        "background-color": $bgcolor
      });
    }).resize();

    var options = {
      offset: $offset.top,
      // tolerance: $height,
      classes: {
        // when element is initialised
        initial: "navbar--headroom",
        // when scrolling up
        pinned: "navbar--pinned",
        // when scrolling down
        unpinned: "navbar--unpinned",
        // when above offset
        top: "navbar--top",
        // when below offset
        notTop: "navbar--not-top",
        // when at bottom of scoll area
        bottom: "navbar--bottom",
        // when not at bottom of scroll area
        notBottom: "navbar--not-bottom"
      },
      // callback when pinned, `this` is headroom object
      onPin: function() {},
      // callback when unpinned, `this` is headroom object
      onUnpin: function() {},
      // callback when above offset, `this` is headroom object
      onTop: function() {},
      // callback when below offset, `this` is headroom object
      onNotTop: function() {},
      // callback at bottom of page, `this` is headroom object
      onBottom: function() {},
      // callback when moving away from bottom of page, `this` is headroom object
      onNotBottom: function() {}
    }

    $navbar.headroom(options);

  }

  // });

})(jQuery);